// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__QClwY","wrapper":"Loader_wrapper__sadND","text":"Loader_text__C2DZZ","overlay":"Loader_overlay__mQOes","legend":"Loader_legend__wjgvy"};